var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2788 26.0995V15.9125H8.88281V11.6678H12.2788V8.27175C12.2788 4.76271 14.4998 3.03644 17.6295 3.03644C19.1286 3.03644 20.4178 3.14829 20.7937 3.19788V6.86491H18.6223C16.9203 6.86491 16.5236 7.67557 16.5236 8.86217V11.6678H20.7672L19.9185 15.9114H16.5236L16.5916 26.0995",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.6e6ff4767c4ef983027e20a1b42bfe1c.svg";
export { ForwardRef as ReactComponent };